"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("../styles");
var CircularProgressWithLabel_1 = __importDefault(require("./CircularProgressWithLabel"));
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var Utils_1 = require("../Utils");
var ProgressBar = function (_a) {
    var successIcon = _a.successIcon, uploadIcon = _a.uploadIcon, deleteIcon = _a.deleteIcon, loadMessage = _a.loadMessage, cancelLabel = _a.cancelLabel, files = _a.files, onDelete = _a.onDelete;
    var classes = (0, styles_1.useStyles)();
    var _b = react_1.default.useState(files.length * -100), progress = _b[0], setProgress = _b[1];
    react_1.default.useEffect(function () {
        var x = files.length * -100;
        files.forEach(function (file) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, Utils_1.uploadFile)(file)];
                    case 1:
                        _a.sent();
                        x = x + 100;
                        setProgress(x);
                        return [2 /*return*/];
                }
            });
        }); });
    }, []);
    return (react_1.default.createElement(core_1.Grid, { item: true },
        react_1.default.createElement(CircularProgressWithLabel_1.default, { successIcon: successIcon, uploadIcon: uploadIcon, value: progress, files: files }),
        progress === 0 ? (react_1.default.createElement(core_1.Grid, null,
            react_1.default.createElement(core_1.Typography, { className: classes.progressBarTypo1 }, files[files.length - 1].name),
            react_1.default.createElement(core_1.Grid, { className: classes.progressBarGrid },
                react_1.default.createElement(core_1.IconButton, { onClick: function () { return onDelete(); } },
                    react_1.default.createElement("i", { className: "".concat(deleteIcon, " colorIcon"), id: "trashUploaderIcon" }))))) : (react_1.default.createElement(core_1.Grid, null,
            react_1.default.createElement(core_1.Typography, { className: classes.progressBarTypo2 }, loadMessage),
            react_1.default.createElement(core_1.Grid, { justify: "space-between", alignItems: "center" },
                react_1.default.createElement(core_1.Button, { onClick: function () { return onDelete(); }, className: classes.progressBarButton }, cancelLabel))))));
};
exports.default = ProgressBar;
